import './index.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import { WebBuildElement, webBuildLoader } from '@ripe/webtoolkit/webbuild';
import App from './App';
import { config } from './config';
import { ErrorElement } from './ErrorElement';
import { loader } from './loader';

window.webBuildId = config.webBuildId = !window.webBuildId && import.meta.env.DEV ? config.webBuildId : (window.webBuildId as string);
window.juiceWebApiUrl = config.juiceWebApiUrl = !window.juiceWebApiUrl && import.meta.env.DEV ? config.juiceWebApiUrl : (window.juiceWebApiUrl as string);
window.paymentUrl = config.paymentUrl = !window.paymentUrl && import.meta.env.DEV ? config.paymentUrl : (window.paymentUrl as string);
window.reCaptchaSiteKey = config.reCaptchaSiteKey = !window.reCaptchaSiteKey && import.meta.env.DEV ? config.reCaptchaSiteKey : window.reCaptchaSiteKey;

window.sentryOptions = {
  dsn: 'https://5d4a52c2703d4a17bf237e6203b92861@monitor.ripethinking.co.uk/9',
};

const queryClient = new QueryClient();

const router = createHashRouter(
  [
    {
      element: <App />,
      children: [
        {
          path: `/*`,
          element: <WebBuildElement config={config} />,
          loader: webBuildLoader(config, queryClient),
          errorElement: <ErrorElement redirectDelay={5000} redirectTo="../" />,
        },
      ],
    },
  ],
  {
    basename: window.baseUrl,
  }
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} fallbackElement={loader} />
  </QueryClientProvider>
);
